var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"grey lighten-4"}},[_c('v-skeleton-loader',{attrs:{"max-height":_vm.maxHeight,"type":"card"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }